import PropTypes from "prop-types";
import React from "react";

import { InformationTip } from "@swa-ui/core";
import i18n from "@swa-ui/locale";
import { PlacementFactory, usePlacement } from "@swa-ui/placements";
import { classNames } from "@swa-ui/string";

import styles from "./PlacementInfoLabel.module.scss";

/**
 * Renders a label with an information tip icon that displays content from a placement ID.
 *
 * This component handles the timing issues with placement content loading by ensuring a re-render
 * after the component has mounted. This allows the PlacementFactory to properly initialize and
 * load the content associated with the provided placement ID.
 *
 */
export const PlacementInfoLabel = (props) => {
  const { className, label, placementId } = props;
  const { placement } = usePlacement(placementId);

  return (
    <>
      {i18n(label)}
      {placement && <InformationTip {...getInformationTipProps()} />}
    </>
  );

  function getInformationTipProps() {
    return {
      className: classNames(styles.informationTip, className),
      content: <PlacementFactory id={placementId} />,
      location: "above",
      size: "small",
    };
  }
};

PlacementInfoLabel.propTypes = {
  /** Additional class name for the information tip. */
  className: PropTypes.string,

  /** Label text i18n key. */
  label: PropTypes.string.isRequired,

  /** Placement id for the information tip. */
  placementId: PropTypes.string.isRequired,
};
